<script setup lang="ts">
import { type HeaderWithChildren, useActiveAnchor } from '~/composables/outline';
import TocOutlineListItem from '~/views/docs/components/TocOutlineListItem.vue';

const props = defineProps<{
  headers: HeaderWithChildren[];
  nested?: boolean;
  container?: HTMLElement;
  marker?: HTMLElement;
}>();

if (props.container && props.marker) {
  useActiveAnchor(props.container, props.marker);
}
</script>

<template>
  <ul :class="nested ? 'pl-4' : 'relative z-1'">
    <TocOutlineListItem v-for="header in headers" :key="header.link" :header="header" />
  </ul>
</template>
